import { ArrowRight, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";
import SectionFadeIn from "@/components/SectionFadeIn";

const NEXT_STEPS = [
  "We review your brief and attachments",
  "You receive a detailed quote by email",
  "We answer any follow-up questions",
];

/**
 * Success confirmation view rendered after a quote is submitted.
 * Self-contained — no state, no handlers.
 */
export default function QuoteSuccessView() {
  return (
    <div
      className="py-28 md:py-36 max-w-xl mx-auto px-6 text-center"
      data-testid="quote-success"
    >
      <SectionFadeIn>
        <div className="w-14 h-14 rounded-full bg-green-900/30 border border-green-700/30 flex items-center justify-center mx-auto mb-6">
          <CheckCircle size={28} strokeWidth={1.6} className="text-green-400" />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tight text-brand-text">
          We&rsquo;ve Got Your Request
        </h1>
        <p className="mt-4 text-[14px] text-brand-text-secondary leading-relaxed max-w-sm mx-auto">
          Our team will review your project details and come back with a clear quote within 24 hours.
        </p>

        <div className="mt-10 space-y-3 text-left max-w-xs mx-auto">
          <p className="text-[11px] tracking-[0.2em] uppercase font-semibold text-brand-gold">
            What Happens Next
          </p>
          {NEXT_STEPS.map((step, i) => (
            <div key={step} className="flex items-start gap-3">
              <span className="text-[12px] text-brand-gold/40 font-heading mt-0.5">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-[13px] text-brand-text-secondary leading-snug">{step}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-white/[0.05]">
          <p className="text-[12px] text-brand-text-secondary/60 mb-3">
            While you wait, browse our collections:
          </p>
          <div className="flex items-center justify-center gap-4">
            <Link
              to="/canvas-category-landing"
              className="text-[12px] text-brand-text-secondary hover:text-brand-gold transition-colors font-medium flex items-center gap-1"
              data-testid="success-canvas-link"
            >
              Canvas Prints <ArrowRight size={12} />
            </Link>
            <span className="text-brand-border text-[10px]">/</span>
            <Link
              to="/wall-murals-landing"
              className="text-[12px] text-brand-text-secondary hover:text-brand-gold transition-colors font-medium flex items-center gap-1"
              data-testid="success-murals-link"
            >
              Wall Murals <ArrowRight size={12} />
            </Link>
          </div>
        </div>
      </SectionFadeIn>
    </div>
  );
}
